import { c as _c } from "react/compiler-runtime";
import { TRANSACTIONS_API } from 'modules/payment/transactions/api/transactions-api';
import { TransactionFilterInterface } from 'modules/payment/transactions/types/transaction-filter-interface';
import { TransactionApiInterface } from 'modules/payment/transactions/types/transaction-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string';
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseTransactionInterface extends SwrPaginationInterface {
  filter: TransactionFilterInterface;
}
export function useTransactions(t0) {
  const $ = _c(14);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== filter || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => user && [`${TRANSACTIONS_API}/list/v2?${getPaginationAndFilterQueryString({
      limit,
      pagination,
      filter: {
        ...filter
      }
    })}`, RequestModuleEnum.Contacts];
    $[1] = filter;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: transactions,
    mutate
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[6] !== filter || $[7] !== user) {
    t3 = () => user && `${TRANSACTIONS_API}/count/v2?${getFilterQueryString({
      filter: {
        ...filter
      }
    })}`;
    $[6] = filter;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: counter,
    mutate: mutateCounter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[9] !== counter || $[10] !== mutate || $[11] !== mutateCounter || $[12] !== transactions) {
    t4 = {
      transactions,
      mutate,
      counter,
      mutateCounter
    };
    $[9] = counter;
    $[10] = mutate;
    $[11] = mutateCounter;
    $[12] = transactions;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}